import { styled } from '@mui/material/styles';
import { Dialog, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';

import DocumentsHeader from './BasicDialogHeader';
import { useAppSelector } from '../../hooks/useAppSelector';
import Vehicles from '../home/vehicles/Vehicles';
import * as providerSlice from '../../data/provider.slice';
import { Provider } from '../../data/models/provider.model';

const PREFIX = 'OnboardVehiclesDialog';

const classes = {
  content: `${PREFIX}-content`,
};

const RootDialog = styled(Dialog)(() => ({
  [`& .${classes.content}`]: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
  },
}));

interface OnboardVehiclesDialogProps {
  open: boolean;
  close: () => void;
}

export default function OnboardVehiclesDialog({
  open,
  close,
}: OnboardVehiclesDialogProps) {
  const { t } = useTranslation('common');
  const provider = useAppSelector(providerSlice.selectProvider) as Provider;

  const handleClose = () => {
    close();
  };

  return (
    <RootDialog fullScreen open={open} onClose={handleClose}>
      <DocumentsHeader title={t('onboard.vehicles')} close={close} />
      <DialogContent className={classes.content}>
        <Vehicles provider={provider} isOnboarding canCreate />
      </DialogContent>
    </RootDialog>
  );
}
